<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="primary">
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          color="primary"
          @click="editAction()"
        >
          <v-list-item-avatar size="20">
            <v-icon size="20">
              mdi-eye
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            Visualizar detalhes
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          color="primary"
          @click="closingStoreAction()"
        >
          <v-list-item-avatar size="20">
            <v-icon size="20">
              mdi-wrench
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            Habilitar Encerramento
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          color="primary"
          @click="navigateToProducts()"
        >
          <v-list-item-avatar size="20">
            <v-icon size="20">
              mdi-view-list
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            Ver produtos
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          color="primary"
          :disabled="isDisabled"
          loading
          @click="syncProducts()"
        >
          <v-list-item-avatar
            v-if="!loading"
            size="20"
          >
            <v-icon size="20">
              mdi-update
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content v-if="!loading">
            Sincronizar produtos
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          color="primary"
          :disabled="isDisabled"
          loading
          @click="syncAddress()"
        >
          <v-list-item-avatar
            v-if="!loadingAddress"
            size="20"
          >
            <v-icon size="20">
              mdi-update
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content v-if="!loadingAddress">
            Sincronizar endereço
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import DataTableTextColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableTextColumn.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import eventBus from '@/plugins/eventBus';
import StoreRequest from '../../services/StoreRequest';

export default {
  name: 'UserStoreActionColumn',
  extends: DataTableTextColumnVue,
  mixins: [ServiceMixin, RouterMixin],
  props: {
    row: {
      type: Object,
      default() {
        return {
          idClienteSgv: '',
          numEndereco: '',
          txtComplementoEndereco: '',
        };
      },
    },
  },
  data: () => ({
    requestClass: StoreRequest,
    loading: false,
    loadingAddress: false,
  }),
  computed: {
    getRow() {
      return this.row;
    },
    getId() {
      return this.value;
    },
    isDisabled() {
      return !this.row.idClienteSgv;
    },
    getAddressPayload() {
      const { idClienteSgv, numEndereco, txtComplementoEndereco } = this.row;

      return {
        complemento: txtComplementoEndereco,
        numero: numEndereco,
        sgvClientId: idClienteSgv,
      };
    },
  },
  methods: {
    closingStoreAction() {
      eventBus.$emit('store-closing', this.getRow);
    },
    navigateToProducts() {
      this.editAction(
        this.getRow,
      );
      this.$nextTick(
        () => {
          this.$root.$emit('open-user-store-product', this.getId);
        },
      );
    },
    editAction() {
      this.handleStoreId(
        this.getId,
      );
    },
    syncProducts() {
      this.loading = true;
      this.callService(
        this.requestClass.syncProducts(
          this.getId,
        ),
        {
          successMessage: 'Sucesso ao sincronizar produtos da loja!',
          errorMessage: 'Falha ao sincronizar produtos da loja!',
        },
        () => {
          this.loading = false;
        },
      );
    },
    syncAddress() {
      this.loadingAddress = true;
      this.callService(
        this.requestClass.syncAddress(
          this.getAddressPayload,
        ),
        {
          successMessage: 'Sucesso ao sincronizar endereço da loja!',
          errorMessage: 'Falha ao sincronizar endereço da loja!',
        },
        () => {
          this.loadingAddress = false;
        },
      );
    },
  },
  inject: {
    handleStoreId: {
      default() {
        return () => {};
      },
    },
  },
};
</script>
